const content: { [key: string]: any } = {
  title: {
    pageTitle: "Watchlist",
    description: "",
  },
  search: "Search",
  searchPlaceholder: "Search by name or ABO#",
  clearSearch: "Clear search",
  export: {
    button: "Export",
    description: "This report will include a list of ABOs on your watchlist.",
  },
  table: {
    columns: {
      groupPV: "GPV",
      ppvRequirement: "PPV",
      personalPV: "Personal PV",
      personalPVRequirement: "PPV Target",
      bonusPercent: "Bonus %",
      groupBV: "GBV",
      totalCustomerCount: "Total Customers",
      groupPVNeeded: "GPV Needed",
      qualifiedLegs: "Qualified Legs",
      customerPV: "Customer PV",
      rubyPV: "Ruby PV",
      totalABOCount: "Total ABO",
      personalOrdersCount: "Personal Orders",
      groupOrdersCount: "Group Orders",
      totalNewABOCount: "Total New ABOs",
      annualPPV: "Annual PPV",
      vcsPV: "VCS PV",
      nonVCSPV: "Non VCS PV",
      personalVcsPercent: "Personal VCS %",
    },
  },
  noDownlines: "You do not currently have any downlines on your Watchlist.",
  toggleButton: {
    addLabel: "Add to Watchlist",
    removeLabel: "Remove from Watchlist",
  },
} as const;

export default content;
